import { useProductShipping } from '@util/hooks/useProductShipping';
import type { ProductDocument } from 'models/product';
import type { UserDocument } from 'models/user';

type ProductShippingEstimateProps = {
  product: ProductDocument;
  userDoc: UserDocument | null | undefined;
};

export default function ProductShippingEstimate({
  ...props
}: ProductShippingEstimateProps) {
  const { deliveryRange, shouldShow, isMXLockerDirect } = useProductShipping({
    product: props.product,
    userDoc: props.userDoc,
  });

  if (!shouldShow) return null;

  if (isMXLockerDirect) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-[1.6rem] font-medium text-zinc-700 sm:text-[1.7rem]">
          Free delivery in{' '}
          <span className="font-medium text-black">{deliveryRange}</span>
        </span>
      </div>
    );
  }

  return (
    <span className="text-[1.6rem] font-medium text-zinc-600 sm:text-[1.7rem]">
      Free delivery
    </span>
  );
}
